import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Context } from '../Context/Context'
import { useNavigate } from 'react-router-dom'
import ConfirmLogOut from './ConfirmLogOut'

const AdvancedSettings = ({ TransactionType }) => {
    const navigate = useNavigate()

    const [onDelete, setOnDelete] = useState(false)
    const [onLogOut, setOnLogOut] = useState(false)
    const [count, setCount] = useState(5)
    const [showConfirm, setShowConfirm] = useState(false) // modal state

    const { setDeleted, handleNoDelete, deleted } = useContext(Context)



    const handleCancel = () => {
        if (deleted) return
        setOnDelete(false)
        setShowConfirm(false)
        handleNoDelete()
    }

    const handleDeleteAccount = useCallback(async () => {
        try {
            const token = localStorage.getItem('token')
            const profile = JSON.parse(localStorage.getItem('UserProfile')) // parse object

            if (!profile?.id || !token) return

            const res = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/account/${profile.id}`,
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: `Token ${token}`,
                        Accept: 'application/json',
                    },
                }
            )

            if (!res.ok) {
                const data = await res.json()
                throw new Error(data.message || 'Account deletion failed')
            }

            setDeleted(true)

            setTimeout(() => {
                localStorage.clear()
                navigate('/')
            }, 3000)
        } catch (err) {
            console.error('Delete failed:', err)
            setOnDelete(false)
            setCount(5)
        }
    }, [navigate, setDeleted, setOnDelete, setCount])

    // Countdown effect
    useEffect(() => {
        if (onDelete) {
            if (count === 0) {
                handleDeleteAccount() // call backend when countdown finishes
                return
            }
            const timer = setTimeout(() => setCount((prev) => prev - 1), 1000)
            return () => clearTimeout(timer)
        } else {
            setCount(5)
        }
    }, [onDelete, count, handleDeleteAccount])

    return (
        <div
            className={
                TransactionType === 'Advanced'
                    ? 'flex flex-col relative gap-10 lg:w-[90%]'
                    : 'hidden'
            }
        >
            <div className='flex flex-col gap-1'>
                <p className='text-[18px] font-medium text-[#1D1C1F]'>
                    Advanced settings
                </p>
            </div>

            {/* Logout Section */}
            <div>
                <p className='text-[16px] font-medium text-[#1D1C1F] mb-1'>Log Out!</p>
                <p className='text-[16px] font-normal text-[#525154]'>
                    Logging out will end your current session. You can log back in at any
                    time to continue using your account.
                </p>
                <button
                    onClick={() => setOnLogOut(!onLogOut)}
                    className='text-white rounded-lg py-[10px] mt-3 text-[14px] font-medium px-4 bg-[#EF4444]'
                >
                    Log out now
                </button>
                <ConfirmLogOut onLogOut={onLogOut} setOnLogOut={setOnLogOut} />
            </div>

            {/* Danger Zone */}
            <div className='flex md:flex-row flex-col md:gap-5 gap-8'>
                <div className='md:w-[40%]'>
                    <p className='text-[16px] font-medium text-[#1D1C1F] mb-1'>
                        Danger zone
                    </p>
                    <p className='text-[16px] font-normal text-[#525154]'>
                        Deleting your account will delete all of your client information
                        and invoices, as well as any payment made and payout information.
                    </p>
                </div>

                {/* Before delete */}
                {!onDelete && (
                    <div className='flex flex-col gap-4 md:w-[70%]'>
                        <button
                            onClick={() => setShowConfirm(true)} // open modal
                            className='text-white rounded-lg py-[10px] mt-3 md:w-[40%] 2xl:w-[30%] sp:w-[50%] w-[65%] text-[14px] font-medium px-4 bg-[#EF4444]'
                        >
                            Delete your account
                        </button>
                    </div>
                )}

                {/* During countdown */}
                {onDelete && (
                    <div className='md:w-[70%]'>
                        {count > 0 ? (
                            <p className='text-[#1D1C1F] text-[14px] font-normal'>
                                Your account will be deleted in {count}...
                            </p>
                        ) : (
                            <p className='text-[#1D1C1F] text-[14px] font-normal'>
                                Your account has been deleted.
                            </p>
                        )}
                        <span
                            onClick={handleCancel}
                            className={`text-[14px] text-[#531CB3] font-medium mt-1 ${deleted
                                ? 'cursor-not-allowed'
                                : 'text-[#531CB3] cursor-pointer'
                                }`}
                        >
                            Cancel deletion
                        </span>
                    </div>
                )}
            </div>

            {/* Confirm Delete Modal */}
            {showConfirm && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
                    <div className='bg-white rounded-lg p-6 w-[90%] max-w-md shadow-lg'>
                        <h2 className='text-lg font-semibold text-[#1D1C1F] mb-3'>
                            Confirm account deletion
                        </h2>
                        <p className='text-sm text-[#525154] mb-5'>
                            Are you sure you want to delete your account? This action cannot
                            be undone.
                        </p>
                        <div className='flex justify-end gap-3'>
                            <button
                                onClick={() => setShowConfirm(false)}
                                className='px-4 py-2 rounded-lg border border-gray-300 text-sm'
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    setShowConfirm(false)
                                    setOnDelete(true)
                                }}
                                className='px-4 py-2 rounded-lg bg-[#EF4444] text-white text-sm'
                            >
                                Yes, Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AdvancedSettings
